export interface DuplicateAccountUser {
  id: string;
  full_name: string;
  preferred_email: string | null;
  preferred_phone_number: string | null;
  otpless_identifier: string;
  created_at: string;
  document_ids: Record<string, string>;
  has_identifiers: boolean;
  bundle_usage_count: number;
  note_count: number;
  prescription_count: number;
  invoice_count: number;
}

export interface DuplicateAccountGroup {
  otpless_identifier: string;
  users: DuplicateAccountUser[];
  user_count: number;
}

export interface DuplicateAccountsResponse {
  groups: DuplicateAccountGroup[];
  total: number;
  page: number;
  lastPage: number;
  nextPage: number | null;
}

/**
 * Pick the user to keep when auto-merging a group.
 * Priority: has_identifiers → newest created_at
 */
export function resolveTargetUser(
  users: DuplicateAccountUser[]
): DuplicateAccountUser {
  return (
    users.find((u) => u.has_identifiers) ??
    [...users].sort(
      (a, b) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    )[0]
  );
}
